import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Amplify } from "aws-amplify";
import config from "./aws-exports";
import { UserProvider } from "./components/user/UserContext";
import { ThemeProvider } from "./components/ThemeContext";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux"; // Import Provider from react-redux
import store from "./redux/store"; // Import the Redux store

// Find the User Pool ID for your production deployment in
// the AWS Console
if (config.aws_user_pools_id === "eu-central-1_x0SK7PJdT") {
  config.oauth.domain = "auth.fluentserbian.com";
}

Amplify.configure(config);

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      {/* Wrap your app with Redux Provider */}
      <UserProvider>
        <ThemeProvider>
          <Router>
            <App />
          </Router>
        </ThemeProvider>
      </UserProvider>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
